import React from "react";
import { Table } from "antd";
import PropTypes from "prop-types";

export const SelectAntTable = (props) => {
  const { tableData, tableColumns, tableTitle, onSelect, footer } = props;
  const defaultTitle = () => <h3>{tableTitle}</h3>;

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      onSelect(selectedRows);
    },
  };

  const tableProps = {
    bordered: true,
    // size: "small",
    // tableLayout: "fixed",
    title: tableTitle ? defaultTitle : undefined,
    rowSelection: {
      type: "checkbox",
      ...rowSelection,
    },
  };

  return (
    <Table
      {...tableProps}
      columns={tableColumns}
      dataSource={tableData}
      pagination={false}
      footer={() => footer}
    />
  );
};

SelectAntTable.propTypes = {
  tableData: PropTypes.arrayOf({}),
  tableColumns: PropTypes.arrayOf({}),
  tableTitle: PropTypes.string,
};
